import {
  type Action,
  combineReducers,
  configureStore,
  type ThunkAction,
} from '@reduxjs/toolkit'
import authSliceReducer from '@/features/auth/slice'
import bulkEditReducer from '@/features/bulk-edit/slice'
import mediaSliceReducer from '@/features/media/slice'
import mediaDetailsSliceReducer from '@/features/media-details/slice'
import searchSliceReducer from '@/features/search/slice'
import toastsSliceReducer from '@/features/toasts/slice'
import { apiSlice } from '@/redux/api-slice'

const reducer = combineReducers({
  auth: authSliceReducer,
  toasts: toastsSliceReducer,
  media: mediaSliceReducer,
  bulkEdit: bulkEditReducer,
  search: searchSliceReducer,
  mediaDetails: mediaDetailsSliceReducer,
})

export const store = configureStore({
  reducer: {
    reducer,
    api: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
